import Store from 'lightningjs-redux';
import {
  getPairingStatus,
  getPairingToken,
  getPairingURI,
  getPollingInterval,
} from '../../../logic/pairing/pairing.selectors';
import { getDeepLink } from '../../../logic/routing/routing.selectors';

const mapControllers = instance => [
  {
    selector: getPollingInterval,
    callback: value => {
      instance.pollingInterval = value;
    },
  },
  {
    selector: getDeepLink,
    callback: value => {
      instance.deeplink = value;
    },
  },
  {
    selector: getPairingStatus,
    callback: value => {
      instance.pairingStatus = value;
    },
  },
  {
    selector: getPairingToken,
    callback: value => {
      instance.token = value;
    },
  },
  {
    selector: getPairingURI,
    callback: value => {
      instance.url = value;
    },
  },
];

export default Store.control(mapControllers);
